export default [
  {
    path: '/configurar/',
    name: 'configurar',
    title: 'configurar',
    component: () => import('../view/ConfiguracaoView.vue'),
    redirect: { name: 'configurar-tela' },
    children: [
      {
        path: 'tela/saida',
        name: 'configurar-tela-saida',
        component: () => import('../etradeWebConfig/view/EtradeWebSaidaConfig.vue'),
        meta: {
          title: 'configurar tela',
        },
      },
      {
        path: 'tela/ordemServico',
        name: 'configurar-tela-ordemServico',
        component: () => import('../etradeWebOrdemServicoConfig/views/ETradeWebOrdemServicoConfigView.vue'),
        meta: {
          title: 'Configurar tela de ordem de serviço',
        },
      },
      {
        path: 'tela/carneRapido',
        name: 'configurar-tela-carneRapido',
        component: () => import('../etradeWebRecebiveisCarneRapidoConfig/views/ETradeWebRecebiveisCarneRapidoConfigView.vue'),
        meta: {
          title: 'Configurar tela de carnê rápido',
        },
      },
      {
        path: 'tela/entrada',
        name: 'configurar-tela-entrada',
        component: () => import('../etradeWebEntradaConfig/views/ETradeWebEntradaConfig.vue'),
        meta: {
          title: 'configurar tela',
        },
      },
      {
        path: 'tela/transferencia',
        name: 'configurar-tela-transferencia',
        component: () => import('../etradeWebTransferenciaConfig/views/ETradeWebTransferenciaConfigView.vue'),
        meta: {
          title: 'Configurar tela de transferência',
        },
      },
      {
        path: 'tela/gourmet',
        name: 'configurar-tela-gourmet',
        component: () => import('../gourmetConfig/views/ETradeWebGourmetConfigView.vue'),
        meta: {
          title: 'Configurar tela de gourmet',
        },
      },
    ],
  },
];
